function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Icons/Arrow - right");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "All-Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Home---1820x1024",
  transform: "translate(-887.000000, -720.000000)",
  fill: "#BBBEBF"
}, React.createElement("g", {
  id: "popup",
  transform: "translate(664.000000, 557.000000)"
}, React.createElement("g", {
  id: 1
}, React.createElement("g", {
  id: "Icons/Arrow---right",
  transform: "translate(218.000000, 160.000000)"
}, React.createElement("g", {
  id: "Icons/Arrow---dropdown",
  transform: "translate(8.000000, 8.000000) scale(-1, 1) rotate(-270.000000) translate(-8.000000, -8.000000) translate(3.000000, 5.000000)"
}, React.createElement("path", {
  d: "M4.9999834,6 C4.82076305,6 4.64156483,5.92797172 4.50492535,5.784218 L0.205141796,1.25831682 C-0.0683805987,0.970413351 -0.0683805987,0.503627233 0.205141796,0.215840243 C0.478553534,-0.0719467475 0.921934686,-0.0719467475 1.19547921,0.215840243 L4.9999834,4.22060796 L8.80450972,0.215980013 C9.07803212,-0.0718069773 9.52136901,-0.0718069773 9.79475861,0.215980013 C10.0684138,0.503767003 10.0684138,0.970553121 9.79475861,1.25845659 L5.49504145,5.78435777 C5.35833558,5.92813479 5.17913736,6 4.9999834,6 Z",
  id: "Path"
})))))));

var SvgArrowright = function SvgArrowright(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowright, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowright.fd3ef1cd.svg";
export { ForwardRef as ReactComponent };